/**
 * Persists UTM-style attribution from onboarding emails so downstream Firebase events
 * (e.g. first upload, first summary) can include email_campaign / email_cta.
 */

export const EMAIL_ONBOARDING_ATTR_KEY = 'docufy_onboarding_email_attr_v1';

const LANDING_EVENT_FLAG_KEY = 'docufy_onboarding_email_landing_evt_v1';

/**
 * Read stored onboarding email attribution (short string params only).
 */
export function getStoredEmailCampaignAttribution(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {};
  }
  try {
    const raw = sessionStorage.getItem(EMAIL_ONBOARDING_ATTR_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') {
      return {};
    }
    const out: Record<string, string> = {};
    for (const [k, v] of Object.entries(parsed as Record<string, unknown>)) {
      if (typeof v === 'string' && /^[a-zA-Z][a-zA-Z0-9_]*$/.test(k)) {
        out[k] = v.slice(0, 100);
      }
    }
    return out;
  } catch {
    return {};
  }
}

/**
 * Whether we already fired the one-per-session landing event for this campaign.
 */
export function hasRecordedOnboardingEmailLandingEvent(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }
  try {
    return sessionStorage.getItem(LANDING_EVENT_FLAG_KEY) === '1';
  } catch {
    return true;
  }
}

/**
 * Persists the one-per-tab landing flag. Returns whether sessionStorage now reads back as set.
 */
export function markOnboardingEmailLandingEventRecorded(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    sessionStorage.setItem(LANDING_EVENT_FLAG_KEY, '1');
    return sessionStorage.getItem(LANDING_EVENT_FLAG_KEY) === '1';
  } catch {
    return false;
  }
}
